import React from 'react';
import {
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@material-ui/core';
import PersonIcon from '@material-ui/icons/Person';

export const DatadogOnCallEmptyState = () => {
  return (
    <ListItem>
      <ListItemIcon>
        <div style={{ opacity: 0.5 }}>
          <PersonIcon />
        </div>
      </ListItemIcon>
      <ListItemText primary="No one is currently on-call." />
    </ListItem>
  );
};
